import { Path } from './path';
export class OrbitPathLine extends Path {
    path_;
    color;
    solarBody;
    constructor(path, color, solarBody) {
        super(path.length, solarBody);
        this.path_ = path;
        this.validateColor(color);
        this.color_ = color;
        this.solarBody = solarBody;
        this.updateVertBuf(this.path_);
    }
    update() {
        // Do nothing
    }
}
